import React from 'react';
import { SidebarMenuItem } from '../sidebar.types';
import { SidebarSectionItem } from '@wix/design-system';
import { connect } from 'react-redux';
import { StoreState } from '../../../redux/reducers/store.types';
import { getSelectedOrganizationId } from '../../../selectors/organizations/organizations';
import { getSelectedProjectId } from '../../../redux/projects/projects.selectors';
import { compilePath } from '../../../utils/navigation';
import { navigation } from '../../../utils';

interface OwnProps {
  menuItem: SidebarMenuItem;
  isActive: boolean;
}

interface StateProps {
  organizationId?: string;
  projectId?: string;
}

type SidebarMenuItemLinkProps = StateProps & OwnProps;

// TODO: Deprecate "Link"
class SidebarMenuItemLinkComponent extends React.Component<SidebarMenuItemLinkProps> {
  private getPathParams() {
    const { organizationId, projectId } = this.props;

    return {
      organizationId,
      projectId,
    };
  }

  public getCompiledPath(): string {
    const { menuItem } = this.props;

    return compilePath(menuItem.path, this.getPathParams());
  }

  public onClick(event) {
    const { menuItem } = this.props;

    event && event.preventDefault();

    if (event?.metaKey || event?.ctrlKey) {
      window.open(this.getCompiledPath(), '_blank');
    } else {
      navigation.goToPath(menuItem.path, this.getPathParams());
    }
  }

  render() {
    const { menuItem, isActive } = this.props;
    return (
      <SidebarSectionItem
        key={menuItem.id}
        onClick={this.onClick.bind(this)}
        selected={isActive}
      >
        {menuItem.title}
      </SidebarSectionItem>
    );
  }
}
const mapStateToProps = (
  state: StoreState,
  ownProps: SidebarMenuItemLinkProps,
): StateProps => ({
  organizationId: ownProps.organizationId || getSelectedOrganizationId(state),
  projectId: ownProps.projectId || getSelectedProjectId(state),
});

export const SidebarMenuItemLink = connect<StateProps, null, OwnProps>(
  mapStateToProps,
)(SidebarMenuItemLinkComponent);
